/** @format */

import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./ClinicGallery.css";

const ClinicGallery = () => {
	return (
		<div className="clinic-gallery-section" id="gallery">
			<Container>
				<h2 className="section-title text-center mb-5">Clinic Gallery</h2>
				<Row className="justify-content-center">
					{/* Image 1 */}
					<Col md={4} sm={6} xs={12} className="gallery-col mb-4">
						<Image
							src="/lab.jpg"
							alt="Clinic View 1"
							fluid
							className="gallery-img"
						/>
					</Col>
					{/* Image 2 */}
					<Col md={4} sm={6} xs={12} className="gallery-col mb-4">
						<Image
							src="/reception.jpg"
							alt="Clinic View 2"
							fluid
							className="gallery-img"
						/>
					</Col>
					{/* Image 3 */}
					<Col md={4} sm={6} xs={12} className="gallery-col mb-4">
						<Image
							src="/pharmacy.jpg"
							alt="Clinic View 3"
							fluid
							className="gallery-img"
						/>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default ClinicGallery;
